import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useEnableChat = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["chat_enable"],
    mutationFn: async (query) => {
      return await axios.post("/chat/enable", query);
    },
  });
};